import { render, staticRenderFns } from "./BatchSampleDetails.vue?vue&type=template&id=013c30d9&scoped=true"
import script from "./BatchSampleDetails.vue?vue&type=script&lang=js"
export * from "./BatchSampleDetails.vue?vue&type=script&lang=js"
import style0 from "./BatchSampleDetails.vue?vue&type=style&index=0&id=013c30d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013c30d9",
  null
  
)

export default component.exports